export class IOrderNote
{
      
       orderId : number;
        patId  : number;
        encounterId : string;
        appointmentId : string;
        providerId : string;
        orderDate : Date;
        createdBy : string;
        modifiedBy : string;
         createdOn : Date;
         modifiedOn : Date;
        isActive : boolean;
        locationId:number;
}